import Icon from '@components/icon/Icon';

import { CustomTableSortOrder, CustomTableSortState } from './types';

import colors from '../../../themes/colors';

interface CustomTableSortableHeaderProps {
  label: string;
  sortKey: string;
  sortState?: CustomTableSortState | null;
  onSortChange: (sortKey: string, sortOrder: CustomTableSortOrder) => void;
}

const CustomTableSortableHeader = ({
  label,
  sortKey,
  sortState,
  onSortChange
}: CustomTableSortableHeaderProps) => {
  const isActive = sortState?.sortBy === sortKey;
  const sortOrder = isActive ? sortState?.sortOrder : undefined;

  const handleClick = () => {
    if (isActive && sortOrder === 'desc') {
      onSortChange(sortKey, 'asc');
      return;
    }
    onSortChange(sortKey, 'desc');
  };

  return (
    <button
      type="button"
      className="flex items-center gap-1 text-sm font-medium text-cofeeNeutral10"
      onClick={handleClick}
    >
      <span>{label}</span>
      <span className="ml-1.5 flex flex-col leading-none">
        <Icon
          name="up"
          size="12"
          stroke={colors.cofeeGreyBlue500}
          className={sortOrder === 'asc' ? 'opacity-100' : 'opacity-30'}
        />
        <Icon
          name="down"
          size="12"
          stroke={colors.cofeeGreyBlue500}
          className={
            !isActive || sortOrder === 'desc' ? 'opacity-100' : 'opacity-30'
          }
        />
      </span>
    </button>
  );
};

export default CustomTableSortableHeader;
